import type { FaireProductEntity } from "../../entity_types/product";

export const p_3awcacr3jc: FaireProductEntity = {
  token: "p_3awcacr3jc",
  type: "product",
  name: "Building bricks - Four seasons",
  brandToken: "b_59a092qk0m",
  brandName: "Goki America",
  imageUrl:
    "https://cdn.faire.com/fastly/36c5fa7f4f58314298e490f56986f657b93f9c617b8bfaa8251b39334e81468a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ed097be63a5f7e8799b62281b7fd7c076c4cb8c61e4f285a7b80c44e5be0fdb.jpeg",
    "https://cdn.faire.com/fastly/b2c577625687f7499544811cf311cb7e122bde80701f978688ed934d4aa18f68.jpeg",
    "https://cdn.faire.com/fastly/437b4366fc4758cd4fe63427ec28ac9f7f9952ee6c868e1bc28ba865ef0a0afd.jpeg",
    "https://cdn.faire.com/fastly/ce40096ff65824a60607c1b42655affed41ff14a64d8d14b68c0d593b1853bcc.jpeg",
    "https://cdn.faire.com/fastly/492e8129a9a32da78f8c463c8d06b1153aabe9bd3b3067973223385b93d0ef30.jpeg",
    "https://cdn.faire.com/fastly/57725b88c3f28c0bebc1c990f5ca3216e251c88bb4e6b800dc467054be0ed952.jpeg",
    "https://cdn.faire.com/fastly/bbe971c8ec4378c30e4659c21abba3b02a4f768f6f64994e2d647ed9accb9d64.jpeg",
    "https://cdn.faire.com/fastly/5b763a7783a2f59472c4a047b6f334425933a8fb65d1470d32f371fff4090ba5.jpeg",
    "https://cdn.faire.com/fastly/aadb79285dab1b40887430c31e6b1f5e0a9fbdad734aab37a31b0b64798148cf.jpeg",
    "https://cdn.faire.com/fastly/6d571f05cb5b6800cf924b49d9c45afa3bd471bf2bd4455c881a2bb29eee7f9d.jpeg",
    "https://cdn.faire.com/fastly/480f85c92dbb8ddd41a55669a70cd66a38ebad20e9de4f6ca6953fafad66b9de.jpeg",
    "https://cdn.faire.com/fastly/26c20fb52534edefee6eaa944d02f01b2e47bce4cb3f7070aeadb2f748ef239d.png",
  ],
  priceDollars: 54.95,
  description:
    "Explore the Four seasons Building Set, meticulously crafted from maple wood in Europe. Each block is lovingly designed and hand-painted in vibrant rainbow colors, symbolizing the four seasons and encouraging imaginative free play.\n\nThis toy embodies principles from both Montessori and Waldorf educational philosophies, promoting independent learning and the joy of discovery. The organic shapes inspire creativity, appealing especially to older children who enjoy exploring innovative designs.\n\nThe non-lacquered, slightly rough surface enhances building, making it accessible for younger children too. Complementary to other sets, it allows endless combinations for creating diverse play settings.\n\nWith 25 blocks neatly housed in a wooden frame, this set is not just a toy but a tool for fostering spatial perception and creative thinking in children.",
  tags: [],
  msrpDollars: 109.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:52.549Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
